import { Grid } from '@mui/material'
import UploadPolicyTile from 'src/components/Individual/MyPoliciesView/UploadPolicyTile'

const UploadPoliciesView = ({
  uploadPoliciesList = [],
  path,
  policyType,
  clientId,
}) => {
  return (
    <>
      <Grid
        container
        spacing={2}
        alignItems={'stretch'}
        justifyContent={'center'}
      >
        {uploadPoliciesList?.map((tileData) => (
          <Grid
            item
            xs={12}
            sm={6}
            md={6}
            lg={3}
            xl={3}
            key={`uploadPolicyTile_${tileData?.insuranceType}`}
          >
            <UploadPolicyTile
              data={tileData}
              path={path}
              policyType={policyType}
              clientId={clientId}
              policyData={tileData?.label}
            />
          </Grid>
        ))}
      </Grid>
    </>
  )
}

export default UploadPoliciesView
